export interface IEnterprisesType {
  id?: number;
  uuid?: string;
  name: string  
  description: string
  generate_production: boolean
  icon_width: number
  icon_height: number 
  image?: File
  image_text?: String

}


export const EnterprisesTypesInitValues: IEnterprisesType = { 
  name:'' ,
  description: '',
  // file_svg: '',
  generate_production: false,
  icon_width: 0,
  icon_height: 0   
}

